import { html, LitElement } from 'lit';
import { repeat } from 'lit/directives/repeat.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { ToujouStorageBehaviour } from '../../../mixins/toujou-storage-behaviour.js';

class ToujouFavList extends ToujouStorageBehaviour(LitElement) {
  static get is() {
    return 'toujou-fav-list';
  }

  static get properties() {
    return {
      loading: {
        type: Boolean,
      },

      favList: {
        type: Array,
        state: true,
      },

      items: {
        type: Array,
        state: true,
      },

      teaserUrl: {
        type: String,
        attribute: 'teaser-url',
      },

      emptyListMessage: {
        type: String,
        attribute: 'empty-list-message',
      },

      empty: {
        type: Boolean,
        attribute: 'empty',
        reflect: true,
      },
    };
  }

  constructor() {
    super();
    this.loading = false;
    this.empty = false;
    this.items = [];
    this.teaserUrl = '';
    this.emptyListMessage = '';
  }

  createRenderRoot() {
    return this;
  }

  render() {
    let emptyMessageContent = html``;
    if (this.querySelector('.fav-list__empty-content') === null) {
      emptyMessageContent = html`
        <div class="fav-list__empty-message" part="empty-list">
          <p part="empty-list-text">${this.emptyListMessage}</p>
        </div>`;
    }

    return html`
      <div class="fav-list__content" part="content">${this.renderItems}</div>
      ${emptyMessageContent}`;
  }

  updated(_changedProperties) {
    if (_changedProperties.has('items')) {
      this.empty = this.items.length === 0;
    }
  }

  set storageValue(favList) {
    this.favList = favList || [];

    const itemsByCode = {};
    this.items.forEach((item) => {
      itemsByCode[item.code] = item;
    });
    this.items = this.favList.map(
      code => itemsByCode[code] || {
        code,
        loaded: false,
        loading: false,
      },
    );

    this.loadItems();
  }

  get renderItems() {
    return repeat(
      this.items,
      item => item.code,
      item => html` ${item.loaded
        ? html`${unsafeHTML(item.html)}`
        : html`<toujou-spinner></toujou-spinner>`}`,
    );
  }

  loadItems() {
    const itemsToLoad = this.items.filter(
      item => !item.loaded && !item.loading,
    );

    if (!itemsToLoad.length) {
      return;
    }

    itemsToLoad.forEach((item) => {
      item.loading = true;
    });
    this.items = this.items.slice();

    itemsToLoad.forEach((item) => {
      fetch(`${this.teaserUrl}?typoLink=${encodeURIComponent(item.code)}`)
        .then(response => response.text())
        .then((itemHtml) => {
          item.loaded = true;
          item.html = itemHtml;
        })
        .finally(() => {
          item.loading = false;
          this.items = this.items.slice();
        });
    });
  }
}

customElements.define(ToujouFavList.is, ToujouFavList);
